import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios, { all } from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function GarmentBuisnessDetails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
    const [isProfitMarginEditData, setProfitMarginEditData] = useState(false)


    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/GarmentShop/purchase/getbygarmentshopid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [monthData, setMonthData] = useState([])

    const MonthDataFetch = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/Common/months`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setMonthData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        MonthDataFetch()
    }, [])

    const [garmentsBuisnessData, setGarmentsBuisnessData] = useState({
        month: 0,
        year: 0,
        purchaseAmount: 0,
        remark: '',
        garmentShopId: id,
        latitude: '',
        longitude: ''
    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setGarmentsBuisnessData({ ...garmentsBuisnessData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        let response;
        try {
            const response = await axios.post(`${Api_Url}api/v1/GarmentShop/purchase`, garmentsBuisnessData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }



    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/GarmentShop/purchase/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }

            })
            setGarmentsBuisnessData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/GarmentShop/purchase/${id}`, garmentsBuisnessData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully Updated")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }

    const columns = [
        {
            title: "Month",
            dataIndex: "",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
            render: (text, record) => (
                <div>{text.month} - {text.year}</div>
            )
        },
        {
            title: "Purchase Amount",
            dataIndex: "purchaseAmount",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Remark",
            dataIndex: "remark",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Created At",
            dataIndex: "created",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
        // {
        //     title: 'Delete',
        //     dataIndex: 'delete',
        //     // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
        //     render: (text, record) => (
        //       <div>
        //         {text}
        //         <Button
        //          className='btn btn-danger'
        //           type="primary"
        //           // onClick={() => handleClick(record.id)}
        //           style={{ marginLeft: '10px' }}
        //         >
        //         <i class="fa-solid fa-trash"></i>
        //         </Button>
        //       </div>
        //     ),
        //   },
    ];



    // Profit Margin calculation Page All Data

    const [isProfitMArginModalOpen, setIsProfitMarginModalOpen] = useState(false)
    const [garmentProfitMargin, setGarmentProfitMargin] = useState([])

    const AllGarmentsProfitMargin = async () => {
        let response;
        try {
            response = await axios.get(`${Api_Url}api/v1/GarmentShop/item/getbygarmentshopid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setGarmentProfitMargin(response.data.data)
        } catch (error) {
            return error
        }
    }

    useEffect(() => { AllGarmentsProfitMargin() }, [])

    // Add Function


    const [profitMarginData, setProfitMarginData] = useState({
        garmentShopId: id,
        name: "",
        purchaseAmount: 0,
        sellingAmount: 0,
        discount: 0,
        grossProfit: 0,
        latitude: "",
        longitude: ""
    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setProfitMarginData({ ...profitMarginData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const AddGarmentsProfitMargin = async () => {
        let response;
        try {
            response = await axios.post(`${Api_Url}api/v1/GarmentShop/item`, profitMarginData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleProfitMarginCancel()
                AllGarmentsProfitMargin()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }

    // Calculation Of Profit Margin

    // const calculateProfitMargin = () => {
    //     const result = (profitMarginData.sellingAmount - profitMarginData.purchaseAmount - (profitMarginData.discount * profitMarginData.sellingAmount)) / profitMarginData.purchaseAmount * 100 || 0;
    //     setProfitMarginData(prev => ({
    //       ...prev,
    //       grossProfit: result
    //     }))
    //   };

    //   useEffect(()=>{calculateProfitMargin()},[profitMarginData.sellingAmount,profitMarginData.purchaseAmount,profitMarginData.discount])



    const sellingPrice = profitMarginData.sellingAmount || 0; // Assuming 0 as default value if not provided
    const purchasePrice = profitMarginData.purchaseAmount || 0; // Assuming 0 as default value if not provided
    const discount = profitMarginData.discount / 100 || 0; // Assuming 0 as default value if not provided

    const calcGPmargin = ((sellingPrice - purchasePrice - (sellingPrice * discount)) / purchasePrice) * 100 || 0;

    useEffect(() => { setProfitMarginData({ ...profitMarginData, grossProfit: calcGPmargin }) }, [calcGPmargin])

    async function handleProfitMarginCancel() {
        setProfitMarginData({
            ...profitMarginData,
            garmentShopId: id,
            name: "",
            purchaseAmount: 0,
            sellingAmount: 0,
            discount: 0,
            grossProfit: 0,
        })

        setProfitMarginEditData(false)
        setIsProfitMarginModalOpen(false);
    }


    //   SingleUSer Call When Edit

    const handleSingleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/GarmentShop/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }

            })
            setProfitMarginData(response.data.data)
            setProfitMarginEditData(true)
        } catch (error) {
            return error.message
        }
    }


    // Add Edit Method

    const handleProfitMarginUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/GarmentShop/item/${id}`, profitMarginData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully Updated")
                handleProfitMarginCancel()
                AllGarmentsProfitMargin()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }


    //   Columns Grid

    const col = [
        {
            title: "Name",
            dataIndex: "name",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
            // render: (text, record) => (
            //     <div>{text.month} - {text.year}</div>
            // )
        },
        {
            title: "Purchase",
            dataIndex: "purchaseAmount",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Selling Amount",
            dataIndex: "sellingAmount",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "discount",
            dataIndex: "discount",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "GP Margin",
            dataIndex: "grossProfit",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleSingleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
        // {
        //     title: 'Delete',
        //     dataIndex: 'delete',
        //     // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
        //     render: (text, record) => (
        //       <div>
        //         {text}
        //         <Button
        //          className='btn btn-danger'
        //           type="primary"
        //           // onClick={() => handleClick(record.id)}
        //           style={{ marginLeft: '10px' }}
        //         >
        //         <i class="fa-solid fa-trash"></i>
        //         </Button>
        //       </div>
        //     ),
        //   },
    ];


    async function handleCancel() {
        setGarmentsBuisnessData({
            ...garmentsBuisnessData,
            month: 0,
            year: 0,
            purchaseAmount: 0,
            remark: '',
            garmentShopId: id,
        })
     // reset form with initial value 0
        setIsModalOpen(false);
        setIsEditModalOpen(false);
    }

    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">


                    {/* Tabs  */}

                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Assesments</button>
                            <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Profit Margin calculation</button>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">

                            {/* Assesments Tab */}

                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <h3 className="mb-0">Garments</h3>
                                    <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add info</button>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12 mx-auto">
                                    <Table
                                        className="table-striped"
                                        style={{ overflowX: "auto" }}
                                        columns={columns}
                                        dataSource={singleData}
                                        rowKey={(record) => record.id}
                                    />
                                </div>
                            </div>



                            {/* Add MOdal */}
                            <Modal
                                title={<h4>Add info</h4>}
                                open={isModalOpen}
                                onOk={() => setIsModalOpen(false)}
                                onCancel={() => handleCancel()}
                                footer={[
                                    <div className='d-flex justify-content-between align-items-center'>

                                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                                    </div>
                                ]}
                                width={600}
                                mask={false}
                                maskClosable={false}
                                closeIcon={<span style={{ color: 'red' }}>X</span>}
                            >
                                <div className="modal-body mt-5">
                                    <form>
                                        <Divider>Garments Information</Divider>
                                        <div className="row">
                                            <div className="col-sm-6" >
                                                <div className="input-block mb-3">
                                                    <select className="form-control" value={garmentsBuisnessData.month} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, month: e.target.value })}>
                                                        <option value="">Select Month</option>
                                                        {monthData && monthData.length > 0 && monthData.map((res) => (
                                                            <option value={res.id}>{res.name}</option>
                                                        ))}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <select className="form-control" value={garmentsBuisnessData.year} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, year: e.target.value })}>
                                                        <option value="">Select Year</option>
                                                        <option value={2023}>2023</option>
                                                        <option value={2024}>2024</option>
                                                    </select>
                                                    {/* <input className="form-control" type="number" placeholder="Select Year" value={garageAutoData.tat} onChange={(e) => setGarageAutoData({ ...garageAutoData, tat: e.target.value })} /> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        purchase amount:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Daily Grind In kg" value={garmentsBuisnessData.purchaseAmount} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, purchaseAmount: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Remark:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Grind Price" value={garmentsBuisnessData.remark} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, remark: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>

                            {/* Edit Modal */}

                            <Modal
                                title={<h4>Edit info</h4>}
                                open={isEditModalOpen}
                                onOk={() => setIsEditModalOpen(false)}
                                onCancel={() => handleCancel()}
                                footer={[
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(garmentsBuisnessData.id)}>Update</button>
                                    </div>
                                ]}
                                width={600}
                                mask={false}
                                maskClosable={false}
                                closeIcon={<span style={{ color: 'red' }}>X</span>}
                            >
                                <div className="modal-body mt-5">
                                    <form>
                                        <Divider>Garments Information</Divider>
                                        <div className="row">
                                            <div className="col-sm-6" >
                                                <div className="input-block mb-3">
                                                    <select className="form-control" value={garmentsBuisnessData.month} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, month: e.target.value })}>
                                                        {monthData && monthData.length > 0 && monthData.map((res) => (
                                                            <option value={res.id}>{res.name}</option>
                                                        ))}

                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <select className="form-control" value={garmentsBuisnessData.year} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, year: e.target.value })}>
                                                        <option value={2023}>2023</option>
                                                        <option value={2024}>2024</option>
                                                    </select>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        purchase amount:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Daily Grind In kg" value={garmentsBuisnessData.purchaseAmount} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, purchaseAmount: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Remark:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Grind Price" value={garmentsBuisnessData.remark} onChange={(e) => setGarmentsBuisnessData({ ...garmentsBuisnessData, remark: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>

                        </div>

                        {/* 2nd Profit Margin Tabs */}
                        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">

                            {/* Profit Margin Calculation */}

                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <h3 className="mb-0">Profit Margin Calculation</h3>
                                    <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsProfitMarginModalOpen(true)}>Add info</button>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12 mx-auto">
                                    <Table
                                        className="table-striped"
                                        style={{ overflowX: "auto" }}
                                        columns={col}
                                        dataSource={garmentProfitMargin}
                                        rowKey={(record) => record.id}
                                    />
                                </div>
                            </div>

                            <Modal
                                title={<h4>Profit Margin Calculation</h4>}
                                open={isProfitMArginModalOpen}
                                onOk={() => setIsProfitMarginModalOpen(false)}
                                onCancel={() => handleProfitMarginCancel()}
                                footer={[
                                    <div className='d-flex justify-content-between align-items-center'>

                                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleProfitMarginCancel}>Cancel</button>,
                                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={AddGarmentsProfitMargin}>Submit</button>

                                    </div>
                                ]}
                                width={600}
                                mask={false}
                                maskClosable={false}
                                closeIcon={<span style={{ color: 'red' }}>X</span>}
                            >
                                <div className="modal-body mt-5">
                                    <form>
                                        <Divider>Profit Margin</Divider>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Product Name:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Product Name" value={profitMarginData.name} onChange={(e) => setProfitMarginData({ ...profitMarginData, name: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Purchase Price:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Purchase Price" value={profitMarginData.purchaseAmount} onChange={(e) => setProfitMarginData({ ...profitMarginData, purchaseAmount: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Selling Price:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Selling Price" value={profitMarginData.sellingAmount} onChange={(e) => setProfitMarginData({ ...profitMarginData, sellingAmount: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Discount(%):
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Discount (%)" value={profitMarginData.discount} onChange={(e) => setProfitMarginData({ ...profitMarginData, discount: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="row my-3">
                                                <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                                    <p className="mb-0">Gross Profit Margin: </p>
                                                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {profitMarginData.grossProfit.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>


                            {/* Edit Modal */}

                            <Modal
                                title={<h4>Profit Margin Calculation</h4>}
                                open={isProfitMarginEditData}
                                onOk={() => setProfitMarginEditData(false)}
                                onCancel={() => handleProfitMarginCancel()}
                                footer={[
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleProfitMarginCancel}>Cancel</button>,
                                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleProfitMarginUpdate(profitMarginData.id)}>Update</button>
                                    </div>
                                ]}
                                width={600}
                                mask={false}
                                maskClosable={false}
                                closeIcon={<span style={{ color: 'red' }}>X</span>}
                            >
                                <div className="modal-body mt-5">
                                    <form>
                                        <Divider>Profit Margin</Divider>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Product Name:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Product Name" value={profitMarginData.name} onChange={(e) => setProfitMarginData({ ...profitMarginData, name: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Purchase Price:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Purchase Price" value={profitMarginData.purchaseAmount} onChange={(e) => setProfitMarginData({ ...profitMarginData, purchaseAmount: e.target.value })} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Selling Price:
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Selling Price" value={profitMarginData.sellingAmount} onChange={(e) => setProfitMarginData({ ...profitMarginData, sellingAmount: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="input-block mb-3">
                                                    <label className="col-form-label">
                                                        Discount(%):
                                                    </label>
                                                    <input className="form-control" type="text" placeholder="Enter Discount (%)" value={profitMarginData.discount} onChange={(e) => setProfitMarginData({ ...profitMarginData, discount: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className="row my-3">
                                                <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                                    <p className="mb-0">Gross Profit Margin: </p>
                                                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {profitMarginData.grossProfit.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>

                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}

export default GarmentBuisnessDetails
